let state = {
  routeSite: {},
  itemsMenu: [
    { title: 'Home', icon: 'mdi:home-outline', active: true, route: '/home/indicators', permissionCode: 1 },
    { title: 'Pacientes', icon: 'mdi:user-circle-outline', active: false, route: '/patients/list', permissionCode: 2 },
    { title: 'Grupos', icon: 'mdi:dots-grid', active: false, route: '/groups/list', permissionCode: 2 },
    { title: 'Informes', icon: 'mdi:file-report-outline', active: false, route: '/reports/panel', permissionCode: 2 },
    { title: 'Administración', icon: 'mdi:database-outline', active: false, route: '/administration/panel', permissionCode: 1 },
    { title: 'Calendario', icon: 'mdi:calendar-month-outline', active: false, route: '/calendar/grid', permissionCode: 1 },
    { title: 'Configuración', icon: 'mdi:cog-outline', active: false, route: '/configuration/panel', permissionCode: 1 }
  ]
}

let mutations = {
  ROUTE_SITE ( state, route ) { state.routeSite = JSON.parse(JSON.stringify(route))},
  ACTIVATE_ITEM_MENU ( state, payload ) {
    state.itemsMenu.forEach( (item, index) => {
      return item.title.toLowerCase() == payload.toLowerCase() ? state.itemsMenu[index].active = true : state.itemsMenu[index].active = false
    })
  }
}

let actions = {
}
let getters = {}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}